<template>
    <div class="uploadWorks">
      <h4 class="uploadWorks_title">填写作品信息</h4>
      <div class="uploadNoDel">
        * 参赛作品不支持删除，审核通过前上传的作品如需修改,可在【买家工作台-我的活动】点击“编辑”进行修改
      </div>
        <div class="uploadWorks_top">
          <div class="uploadWorks_topBox">
             <div  class="uploadWorks_topTe" ref="nameRef">
              <div class="uploadWorks_topTeMess">
                <p><i class="centerIcon">*</i> 作品名称：</p>
                <div class="uploadWorks_topTe2">
                  <el-input v-model="name" @blur="blurVhtmlBox('name')" maxlength="70" show-word-limit></el-input>
                </div>
              </div>
              <div class="vHtmlIconBox">
                <p class="vHtmlIcon" v-if="nameShow">请填写作品名称</p>
              </div>
            </div>
            <div class="uploadWorks_topTe" ref="typeUuidRef">
              <div class="uploadWorks_topTeMess">
                <p><i class="centerIcon">*</i> 作品类别：</p>
                <el-select v-model="typeUuid" placeholder="请选择">
                  <el-option
                    @blur="blurVhtmlBox('type')"
                    v-for="item in typeList"
                    :key="item.uuid"
                    :label="item.worksType"
                    :value="item.uuid">
                  </el-option>
                </el-select>                
              </div>
              <div class="vHtmlIconBox">
                <p class="vHtmlIcon" v-if="typeUuidShow">请选择作品类别</p>
              </div>
            </div>
          </div>
          <div class="uploadBox" ref="summaryRef">
            <div class="uploadBoxInput">
              <p><i class="centerIcon">*</i> 作品简介：</p>
              <el-input
                class="uploadWorks_textarea"
                type="textarea"
                :rows="2"
                placeholder="请输入内容"
                v-model="summary"
                @blur="blurVhtmlBox('summary')"
                maxlength="250" show-word-limit>
              </el-input>              
            </div>

            <div class="vHtmlIconBox">
              <p class="vHtmlIcon" v-if="summaryShow">请请输入作品简介</p>
            </div>
          </div>
        </div>
        <div class="uploadWorks_bottom" ref="coverUrlRef">
          <div class="uploadWorks_bottomOne">
            <p class="upload_imgboxOneP"><i class="centerIcon">*</i> 作品封面：</p>
            <div class="upload_imgbox">
              <el-upload
                ref="uploadImage"
                action="/service-center/upload/file/single"
                :on-progress="handleProgress"
                :on-success="handleCoverSuccess"
                :headers="headers"
                :limit="1"
                :file-list="coverName"
                :show-file-list="false"
                accept=".jpg,.jpeg,.png">
                <div class="upload_imgboxText" v-if="!coverUrl">
                  <i class="iconfont">&#xec1d;</i>
                  <p>上传参赛作品封面</p>
                </div>
                <img :src="coverUrl" alt="" v-if="coverUrl" class="imgurl">
              </el-upload>              
            </div>              
          </div>
   
          <div>
            <p class="vHtmlIcon" v-if="coverUrlShow">请上传参赛作品封面</p>
          </div>  
        </div>
        <div class="uploadWorks_center" ref="descriptionRef">
          <div class="uploadWorks_center_box">
            <h4> <i class="centerIcon">*</i> 作品说明：</h4>
            <!-- <vue-editor v-model="description" @blur="blurVhtmlBox('description')" :options="editorOption" ></vue-editor> -->
            <vue-editor v-model="description" @blur="blurVhtmlBox('description')" useCustomImageHandler @image-added="handleImageAdded" ></vue-editor>
          </div>
          <p class="vHtmlIcon" v-if="descriptioShow">请填写作品说明</p>
        </div>
        <div class="uploadWorks_worksbtn" ref="uploadworksRef">
          <el-upload
            class="upload-demo"
            ref="upload"
            action="/service-center/upload/file/single"
            :on-progress="handleProgress"
            :on-success="handleWorksSuccess"
            :on-preview="handlePreviewMess"
            :headers="headers"
            >
            <el-button size="small" type="primary">上传参赛作品</el-button>
          </el-upload>
          <p class="vHtmlIcon" v-if="worksUrlShow">请上传参赛作品</p>
            <!-- <div class="upload_imgbox">
              <el-upload
                ref="videoUpload"
                action="/service-center/upload/file/single"
                :on-remove="handleRemove"
                :on-progress="handleProgress"
                :on-success="handleVideoSuccess"
                :headers="headers"
                :limit="1"
                :show-file-list="false">
                <div class="upload_imgboxText" v-if="!videoUrl">
                  <i class="el-icon-upload2"></i>
                  <p>附件上传</p>
                </div>
                <img :src="videoUrl" alt="" v-if="videoUrl" class="imgurl">
              </el-upload>
              <p class="vHtmlIcon" v-if="videoUrlShow">请上传附件</p>
            </div>           -->
        </div>
        <!--<div class="activeDetail_mesBox">
          <el-checkbox v-model="checked" @change="blurVhtmlBox('checked')">我已同意活动承诺书信息</el-checkbox>
          <div class="vHtmlIconBox">
            <p class="vHtmlIcon" v-if="checkedShow">请勾选活动承诺书</p>
          </div>
        </div>-->
        <div class="uploadWorks_btn">
          <el-button class="btn" @click="submitUpload">确认上传</el-button>
        </div>
    </div>
</template>
<script>
import { getActivityTypeList,uploadWorks,getViewUploadWorks,updateUploadWorks, single } from '../../../utils/interface';
export default {
  data(){
    return {
      typeUuid: '',
      headers: {
          'Authorization': 'Bearer ' + this.$cookies.get("api_access_token")	//	可以是授权凭证用的参数值
      },
      summary: '',
      name:'',
      coverUrl: '',
      coverName: [],
      worksUrl: '',
      worksName: '',
      videoUrl: '',
      videoName: '',
      description:'',
      dialogImageMess: true,
      typeList:[],
      form:{},
      uuid:"",
      activityUuid:"",
      checked: false,
      // 校验
      typeUuidShow: false,
      nameShow: false,
      summaryShow: false,
      descriptioShow: false,
      coverUrlShow: false,
      worksUrlShow: false,
      videoUrlShow: false,
      checkedShow: false,
      worksFileList:[],
      editorOption: {
        modules: {
          ImageExtend: {
            loading: true,
            size: 0.02,
            action: 'Bearer' + this.$cookies.get('api_access_token'),
            response: res => {
              return res.data.fileUrl;
            },
            headers: (xhr,formData) => {
              //xhr.setRequestHeader(
              //  "X-Nideshop-Token",
              //  localStorage.getItem("token")
              //);
            }, // 可选参数 设置请求头部
          },
        }
      }
    }
  },
  methods: {
    async handleImageAdded(file, Editor, cursorLocation, resetUploader){
      // console.log('图片上传', );
      var formData = new FormData();
      formData.append("file", file); //第一个file 后台接收的参数名
      let res = await single(formData)
      // console.log('上传成功', res);
      if (res.url) {
        Editor.insertEmbed(cursorLocation, "image", res.url);
        resetUploader();
      }else{
        alert("上传返回失败")
      }
      
    },
    init(uuid){
      this.activityUuid = uuid;
      getActivityTypeList({activityUuid:uuid}).then((res)=>{
        this.typeList = res.data;
      });
      /*getViewUploadWorks(this.activityUuid).then((res)=>{
        if(res!==''){
            this.uuid = res.uuid;
            this.typeUuid = res.typeUuid;
            this.name = res.name;
            this.summary = res.summary;
            this.description = res.description;
            this.coverUrl = res.coverUrl;
            this.worksUrl = res.worksUrl;
            this.videoUrl = res.videoUrl;
            this.videoName = res.videoName;
            this.worksName = res.worksName;
            this.activityUuid = res.activityUuid;
            this.worksFileList = res.worksFileList;
        }
      });*/
    },
    submitUpload(){
      this.form = {
        typeUuid:this.typeUuid,
        name:this.name,
        summary:this.summary,
        description:this.description,
        coverUrl:this.coverUrl,
        worksUrl:this.worksUrl,
        videoUrl:this.videoUrl,
        worksName:this.worksName,
        videoName:this.videoName,
        activityUuid:this.activityUuid,
        worksFileList:this.worksFileList,
    };
      if(
          this.typeUuid != '' && 
          this.name != '' &&
          this.summary != '' &&
          this.description != '' &&
          this.coverUrl && this.worksFileList.length>0){
          if(this.uuid=="") {
            uploadWorks(this.form).then((res) => {
              if (res.success) {
                this.$message.success("上传作品成功");
                // 上传按钮展示
                this.$parent.refreshPage();
              }
            });
          }else{
            this.form.uuid = this.uuid;
            updateUploadWorks(this.form).then((res) => {
              if (res.success) {
                this.$message.success("上传作品成功");
                // 上传按钮展示
                this.$parent.refreshPage();
              }
            });
          }          
      }else {
        if(this.name == ''){
          this.nameShow = true
          this.$refs.nameRef.scrollIntoView({
            //滚动到指定节点
            block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
            behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
          })
        }else {
          this.nameShow = false
        }
        if(this.typeUuid == ''){
          this.typeUuidShow = true
          this.$refs.typeUuidRef.scrollIntoView({
            //滚动到指定节点
            block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
            behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
          })
        }else {
          this.typeUuidShow = false
        }
        if(this.summary == ''){
          this.summaryShow = true
          this.$refs.summaryRef.scrollIntoView({
            //滚动到指定节点
            block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
            behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
          })
        }else {
          this.summaryShow = false
        }
        if(this.description == ''){
          this.descriptioShow = true
          this.$refs.descriptionRef.scrollIntoView({
            //滚动到指定节点
            block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
            behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
          })
        }else {
          this.descriptioShow = false
        }
        if(this.coverUrl == ''){
          this.coverUrlShow = true
          this.$refs.coverUrlRef.scrollIntoView({
            //滚动到指定节点
            block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
            behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
          })
        }else {
          this.coverUrlShow = false
        }
        if(this.worksFileList.length == 0){
          this.worksUrlShow = true
          this.$refs.uploadworksRef.scrollIntoView({
            //滚动到指定节点
            block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
            behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
          })
        }else {
          this.worksUrlShow = false
        }

        // this.typeUuid == '' ? this.typeUuidShow = true :this.typeUuidShow = false
        // this.name == '' ? this.nameShow = true :this.nameShow = false
        // this.summary == '' ? this.summaryShow = true :this.summaryShow = false
        // this.description == '' ? this.descriptioShow = true :this.descriptioShow = false
        // this.coverUrl == '' ? this.coverUrlShow = true :this.coverUrlShow = false
        // this.worksFileList.length == 0 ? this.worksUrlShow = true :this.worksUrlShow = false
      }
    },
    // 上传图片
    handleCoverSuccess(file){
      this.coverUrl = file.url;
      this.coverUrl == '' ? this.coverUrlShow = true :this.coverUrlShow = false
      this.$refs.uploadImage.clearFiles();
    },
    handleWorksSuccess(file){
      //this.worksName.push(file.name)
      //this.worksUrl.push(file.url)
      this.worksFileList.push({name:file.name, url:file.url});
      this.worksFileList.length == 0 ? this.worksUrlShow = true :this.worksUrlShow = false
    },
    handleVideoSuccess(file){
      this.videoName = file.name;
      this.videoUrl = file.url;
      this.videoUrl == '' ? this.videoUrlShow = true :this.videoUrlShow = false
      this.$refs.videoUpload.clearFiles();
    },
    handleProgress(){
    },
    // 点击预览
    handlePreviewMess(file){
      // file.raw.name.endsWith('stl') ||
      // file.raw.name.endsWith('STL') || file.raw.name.endsWith('pdf') ||
      // file.raw.name.endsWith('word') || file.raw.name.endsWith('pdf') 
      // if( file.raw.name.endsWith('jpg') || 
      //     file.raw.name.endsWith('jpeg') || 
      //     file.raw.name.endsWith('png') ) {

      //     console.log('file', file)
      //   }
    },
    // 删除图片
    handleRemove(file, fileList) {
      let removeImgIndxName = this.worksFileList.indexOf(file.response.name)
      //let removeImgIndxUrl = this.worksName.indexOf(file.response.name)
      if(removeImgIndxName >= 0){
        this.worksFileList.splice(removeImgIndxName,1)
      }
      /*if(removeImgIndxUrl >= 0){
        this.worksUrl.splice(removeImgIndxUrl,1)
      }*/
    },
    blurVhtmlBox(classMes){
      if(classMes == 'type'){
        if(this.typeUuid == '' ){
          this.typeUuidShow = true
        }else {
          this.typeUuidShow = false
        }
      } else if(classMes == 'name'){
        if(this.name == '' ){
          this.nameShow = true
        }else {
          this.nameShow = false
        }
      } else if(classMes == 'summary'){
        if(this.summary == '' ){
          this.summaryShow = true
        }else {
          this.summaryShow = false
        }
      } else if(classMes == 'description'){
        if(this.description == '' ){
          this.descriptioShow = true
        }else {
          this.descriptioShow = false
        }
      } /*else if(classMes == 'checked'){
        if(!this.checked){
          this.checkedShow = true
        }else {
          this.checkedShow = false
        }
      }*/
    }
  },
}
</script>
<style scoped lang="less">
.uploadWorks {
  width: 1200px;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0px 0px 10px rgba(43, 69, 100, 0.2);
  border-radius: 10px;
  padding: 36px 51px 61px;
  box-sizing: border-box;
  margin-top: 30px;
  .uploadNoDel {
    font-size: 13px;
    color: #c9c2c2;
    margin-top: 10px;
    margin-bottom: 20px;
  }
  .uploadWorks_title {
    font-size: 18px;
    color: #157EFB;
    margin-bottom: 21px;
  }
  .uploadWorks_top {
    .uploadWorks_topBox {
       display: flex;
       align-items: center;
       justify-content: space-between;
       .uploadWorks_topTe {
         font-size: 14px;
         &:nth-of-type(1){
            width: 50%;
         }
        .uploadWorks_topTeMess {
          display: flex;
          align-items: center;
          p {
            font-size: 14px;
            flex-shrink: 0;
            margin-right: 4px;
          }
          /deep/.el-input__inner {
              height: 30px;
              background: rgba(244, 244, 244, 0.39);
              border: 1px solid #DDDDDD;
          }
          /deep/.el-select .el-input .el-select__caret {
            line-height: 30px;
          }
          /deep/.el-form-item {
            width: 100%;
          } 
          .centerIcon {
            color: #F56C6C;
            font-size: 12px;
          }  
        }
        .vHtmlIconBox {
          height: 20px;
          .vHtmlIcon {
            color: #F56C6C;
            font-size: 12px;
            padding-top: 4px;
          }         
        }


       }
       .uploadWorks_topTe2 {
         width: 83%;
         display: flex;
         align-items: center;
         font-size: 14px;
         p {
           font-size: 14px;
           flex-shrink: 0;
           margin-right: 4px;
         }
         /deep/.el-input__inner {
            width: 100%;
            height: 30px;
            background: rgba(244, 244, 244, 0.39);
            border: 1px solid #DDDDDD;
         }
         /deep/.el-select .el-input .el-select__caret {
           line-height: 30px;
         }
       }
    }
    .uploadBox {

      .uploadBoxInput {
        display: flex;
        align-items: center;     
        p {
          font-size: 14px;
          flex-shrink: 0;
          margin-right: 4px;
        }
        .centerIcon {
          color: #F56C6C;
          font-size: 12px;
        }           
      }
  
      .vHtmlIconBox {
          height: 20px;
          margin-left: 85px;
          .vHtmlIcon {
            color: #F56C6C;
            font-size: 12px;
            padding-top: 4px;
          }
          .centerIcon {
            color: #F56C6C;
            font-size: 12px;
          }           
        }
    }
    .uploadWorks_textarea {
        border: 1px solid #DDDDDD;
        border-radius: 4px;
        font-size: 14px;
        margin-top: 16px;
        /deep/.el-textarea__inner {
          width: 100%;
            background: rgba(244, 244, 244, 0.39);
          height: 57px;
        }
    }
  }
  .uploadWorks_center {
    margin-top: 16px;
    .uploadWorks_center_box {
      display: flex;
      h4 {
        font-size: 14px;
        flex-shrink: 0;
        margin-right: 4px;
      }
      /deep/.quillWrapper {
        width: 100%;
        height: 575px;

      }
      /deep/.ql-container{
        height: 90%;
      }
      /deep/.ql-editor {
        // height: 575px;
      }      
    }

    .vHtmlIcon {
      color: #F56C6C;
      font-size: 12px;
      padding-top: 4px;
      margin-left: 81px;
    }
    .centerIcon {
      color: #F56C6C;
      font-size: 12px;
    }
  }
  .uploadWorks_bottom {
    .uploadWorks_bottomP {
      margin: 29px 0 26px;
      font-size: 18px;
      i {
        display: inline-block;
        width: 15px;
        height: 15px;
        background: #157EFB;
        border-radius: 50%;
        margin-right: 5px;
      }
    }
    .vHtmlIcon {
      color: #F56C6C;
      font-size: 12px;
      padding-top: 4px;
      margin-left: 81px;
    }
    .centerIcon {
      color: #F56C6C;
      font-size: 12px;
    }
    .upload_imgbox_box {
      display: flex;
      align-items: center;
    }
    .uploadWorks_bottomOne {
      display: flex;
      margin-top: 20px;
      .upload_imgboxOneP {
        font-size: 14px;
        flex-shrink: 0;
        margin-right: 4px;
        color: #000;
      }
      .centerIcon {
        color: #F56C6C;
        font-size: 12px;
      } 
    }
    .upload_imgbox {
      position: relative;
      width: 334px;
      height: 182px;
      background: rgba(244, 244, 244, 0.39);
      border: 1px solid #DDDDDD;
      border-radius: 4px;
      color: #157EFB;
      .imgurl {
        width: 334px;
        height: 182px;
        border-radius: 4px;
        border: 1px solid #DDDDDD;
      }
      .upload_img {
        width: 334px;
        height: 182px;
        border-radius: 4px;
        border: 1px solid #DDDDDD;
      }
      .upload_imgboxText {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%,-50%);
        line-height: 63px;
        font-size: 18px;
        i {
          font-size: 46px;
        }
      }
      /deep/.el-upload--picture-card {
        width: 334px;
        height: 182px;
        background: rgba(244, 244, 244, 0.39);
        border: 1px solid #DDDDDD;
        border-radius: 4px;
        color: #157EFB;
      }
    }
  }
  .activeDetail_mesBox {
    margin-top: 38px;
    /deep/.el-radio-button__orig-radio:checked+.el-radio-button__inner {
      color: #FFF;
      width: 108px;

      background-color: #409EFF;
      border-color: #409EFF;
      -webkit-box-shadow: -1px 0 0 0 #409eff;
      box-shadow: -1px 0 0 0 #409eff;
    }
    /deep/.activeDetail .activeDetail_set .activeDetail_setbox .activeDetail_mesBox .activeDetail_mes[data-v-62bacabe] .el-radio-button__orig-radio:checked + .el-radio-button__inner {
      width: 108px;
      border-radius: 4px;
    }
    .vHtmlIconBox {
      height: 20px;
      .vHtmlIcon {
        color: #F56C6C;
        font-size: 12px;
        padding-top: 4px;
      }         
    }
  }
  .uploadWorks_btn {
    margin-top: 63px;
    text-align: center;
    .btn {
      width: 160px;
      height: 40px;
      background: rgba(255, 255, 255, 0.39);
      border: 2px solid #157EFB;
      border-radius: 4px;
      font-size: 14px;
      color: #157EFB;
    }
  }
  .uploadWorks_worksbtn {
    margin-left: 81px;
    margin-top: 20px;
    .vHtmlIcon {
      color: #F56C6C;
      font-size: 12px;
      padding-top: 4px;
    }  
  }
}
</style>



// WEBPACK FOOTER //
// src/components/design/activeList/uploadWorks.vue